import { useEffect } from "react";
import { useMobileChrome } from "../stores/mobileChrome";

/** Hide the mobile bottom tab bar while a sticky action bar is active. */
export function useSuppressMobileBottomNav(active: boolean): void {
  const suppressBottomNav = useMobileChrome((s) => s.suppressBottomNav);
  const releaseBottomNav = useMobileChrome((s) => s.releaseBottomNav);

  useEffect(() => {
    if (!active) return;
    suppressBottomNav();
    return () => releaseBottomNav();
  }, [active, suppressBottomNav, releaseBottomNav]);
}
